import { render, staticRenderFns } from "./speciFication.vue?vue&type=template&id=953a8032&scoped=true"
import script from "./speciFication.vue?vue&type=script&lang=js"
export * from "./speciFication.vue?vue&type=script&lang=js"
import style0 from "./speciFication.vue?vue&type=style&index=0&id=953a8032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953a8032",
  null
  
)

export default component.exports